import { RegistrationStatusEnum } from '../API';

export function calculateCheckInStatus(
  checkedInCount: number,
  guests: number
): RegistrationStatusEnum {
  if (checkedInCount <= 0) return RegistrationStatusEnum.REGISTERED;
  if (checkedInCount >= guests || guests === 0) return RegistrationStatusEnum.CHECKED_IN;
  return RegistrationStatusEnum.PARTIAL_CHECK_IN;
}
